// This is a subset of the events containing the ones we care about. There are
// over 70 possible events, we could look at. To see all the events see:
// https://cdn.bitmovin.com/player/web/8/docs/enums/core_events.playerevent.html

type RsRsu = Record<string, BasicEventItem>;
interface BasicEventItem {
  code: number;
  metadata?: string;
}
export interface EventItem extends BasicEventItem {
  name: string;
}

// Add a name field that is the lowercase of the key.
const addNameField = (events: RsRsu): Record<string, EventItem> =>
  Object.getOwnPropertyNames(events).reduce((result, name) => {
    result[name] = { name: name.toLowerCase(), ...events[name] };
    return result;
  }, {} as Record<string, EventItem>);

export const BitmovinReporterEvents = addNameField({
  Destroy: { code: 102 }, // player instance destroyed...
  DurationChanged: { code: 4, metadata: 'dur' },
  Paused: { code: 9, metadata: 'pos' },
  Play: { code: 10, metadata: 'pos' },
  PlaybackFinished: { code: 6 },
  PlaybackSpeedChanged: { code: 12, metadata: 'rate' },
  Playing: { code: 11 },
  Ready: { code: 2 },
  Seek: { code: 13, metadata: 'pos' }, // VOD: TimeShift for live
  Seeked: { code: 14, metadata: 'pos' },
  SourceLoaded: { code: 7 },
  StallStarted: { code: 15 },
  TimeShift: { code: 13, metadata: 'pos' }, // live version of Seek
  TimeShifted: { code: 14, metadata: 'pos' }, // live version of Seeked
  VideoPlaybackQualityChanged: { code: 103, metadata: 'b' }
});
